// ─────────────────────────────────────────────────────────────
// Project Images
// Centralised here so any path change only needs one edit.
// ─────────────────────────────────────────────────────────────
import imgMentalHealth  from "../assets/projects/project_01.avif";
import imgWholesale     from "../assets/projects/project_02.avif";
import imgNycSat        from "../assets/projects/project_03.avif";
import imgNetflix       from "../assets/projects/project_04.avif";
import imgWildfire      from "../assets/projects/project_aus_wildfire.avif";

import { TechIcons } from "../components/common/TechIcons";

// ─────────────────────────────────────────────────────────────
// Shared Tech Stacks
// Reuse common combinations instead of repeating them inline.
// ─────────────────────────────────────────────────────────────
const stacks = {
  pythonSqlNotebook:  [TechIcons.Python, TechIcons.Pandas, TechIcons.SQLite,    TechIcons.Jupyter],
  pythonVizNotebook:  [TechIcons.Python, TechIcons.Pandas, TechIcons.Matplotlib, TechIcons.Jupyter],
  pythonSqlVizNote:   [TechIcons.Python, TechIcons.Pandas, TechIcons.SQLite,    TechIcons.Matplotlib, TechIcons.Jupyter],
  pythonInteractive:  [TechIcons.Python, TechIcons.Pandas, TechIcons.Plotly],
};

// ─────────────────────────────────────────────────────────────
// Base GitHub URL
// ─────────────────────────────────────────────────────────────
const PORTFOLIO_REPO = "https://github.com/abranco0403/data-analytics-portfolio/tree/main";

// ─────────────────────────────────────────────────────────────
// Projects Archive
// Fields:
//   id            – unique slug (used for routing / keys)
//   year          – year completed
//   projectName   – display title
//   madeAt        – context where project was built (e.g. "DataCamp", "Personal", "University")
//   technologies  – array of TechIcon entries
//   image         – imported asset
//   repoUrl       – GitHub link (required)
//   caseStudyPath – live demo / write-up URL (optional)
// ─────────────────────────────────────────────────────────────
const projectsArchive = [
  {
    id:           "international-student-mental-health",
    year:         2025,
    projectName:  "International Student Mental Health Insights",
    madeAt:       "DataCamp",
    technologies: stacks.pythonVizNotebook,
    image:        imgMentalHealth,
    repoUrl:      `${PORTFOLIO_REPO}/students-mental-health`,
  },
  {
    id:           "wholesale-revenue",
    year:         2025,
    projectName:  "Wholesale Revenue & Product Performance Analysis",
    madeAt:       "DataCamp",
    technologies: stacks.pythonSqlNotebook,
    image:        imgWholesale,
    repoUrl:      `${PORTFOLIO_REPO}/motorcycle-sales-analysis`,
  },
  {
    id:           "nyc-sat",
    year:         2025,
    projectName:  "NYC School Performance Analysis (SQL + Python)",
    madeAt:       "DataCamp",
    technologies: stacks.pythonSqlVizNote,
    image:        imgNycSat,
    repoUrl:      `${PORTFOLIO_REPO}/nyc-sat-analysis`,
  },
  {
    id:           "netflix-90s",
    year:         2025,
    projectName:  "Netflix 90s Catalog Analysis (SQL + Python)",
    madeAt:       "DataCamp",
    technologies: stacks.pythonSqlVizNote,
    image:        imgNetflix,
    repoUrl:      `${PORTFOLIO_REPO}/netflix-movies`,
  },
  {
    id:           "australia-wildfire-analysis",
    year:         2026,
    projectName:  "Australia Wildfire Activity Analysis",
    madeAt:       "Personal",
    technologies: stacks.pythonInteractive,
    image:        imgWildfire,
    repoUrl:      "https://github.com/abranco0403/australia-wildfire-analysis",
    caseStudyPath:"https://aus-wildfire-analysis.netlify.app",
  },
  {
    id:           "retail-pricing-optimization",
    year:         2026,
    projectName:  "Retail Pricing Optimization Analysis",
    madeAt:       "Personal",
    technologies: [TechIcons.SQL, TechIcons.Excel, TechIcons.PowerBI],
    image:        null,
    repoUrl:      "https://github.com/abranco0403/retail-pricing-optimization",
    caseStudyPath: "/projects/retail-pricing-optimization",
  },
];

export default projectsArchive;